import { FC } from 'react';
import cls from './skeleton.module.scss';

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  minWidth?: string | number;
  borderRadius?: string;
  className?: string;
}

export const Skeleton: FC<SkeletonProps> = ({
  width = '100%',
  height = '20px',
  borderRadius = '4px',
  className = '',
  minWidth = 'unset',
}) => {
  return (
    <div
      className={`${cls.skeleton} ${className}`}
      style={{
        width,
        height,
        borderRadius,
        minWidth,
      }}
    />
  );
};
